import { useEffect, useRef } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const WHATSAPP_NUMBER = '5585999325303';

export default function CTASection() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const ctx = gsap.context(() => {
      gsap.fromTo(
        sectionRef.current?.querySelector('.cta-content'),
        { y: 50, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          duration: 0.8,
          ease: 'power3.out',
          scrollTrigger: {
            trigger: sectionRef.current,
            start: 'top 80%',
            toggleActions: 'play none none reverse',
          },
        }
      );
    }, sectionRef);
    return () => ctx.revert();
  }, []);

  return (
    <section ref={sectionRef} className="relative w-full py-32 md:py-40 lg:py-48 px-6 md:px-10 lg:px-16 overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20a%20stunning%20sunset%20over%20a%20calm%20ocean%20with%20golden%20and%20pink%20sky%2C%20silhouette%20of%20palm%20trees%2C%20peaceful%20luxury%20travel%20vibe%2C%20ARRI%20Alexa%20cinematic%20photography%2C%20inspirational%20and%20dreamy%2C%204K%20quality&width=1920&height=1080&seq=cta-bg&orientation=landscape"
          alt="O mundo está esperando por você"
          className="w-full h-full object-cover object-center"
          loading="lazy"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/60"></div>

      {/* Content */}
      <div className="cta-content relative z-10 max-w-3xl mx-auto text-center">
        <h2 className="font-heading text-4xl md:text-6xl lg:text-7xl font-light text-white leading-tight mb-6">
          O mundo está <span className="italic">esperando</span> por você
        </h2>
        <p className="text-white/70 text-base md:text-lg font-light max-w-xl mx-auto mb-10 leading-relaxed">
          Não espere mais para realizar a viagem dos seus sonhos. Nossa equipe de especialistas está pronta para criar uma experiência única e inesquecível para você.
        </p>
        <a
          href={`https://wa.me/${WHATSAPP_NUMBER}?text=Olá! Quero planejar minha viagem dos sonhos com a Ao Redor do Mundo Viagens.`}
          target="_blank"
          rel="noopener noreferrer"
          className="group inline-flex items-center gap-3 px-10 py-5 bg-white text-primary-800 rounded-full text-base font-medium tracking-wide hover:bg-white/95 transition-all duration-500 whitespace-nowrap cursor-pointer"
        >
          Quero planejar minha viagem
          <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform duration-300"></i>
        </a>
      </div>
    </section>
  );
}